<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('settings/settings:update.updates') }}
        </h2>

        <DataTablePaginated
            ref="table"
            class="ma-1"
            :headers="headers"
            :addBtnText="$t('buttons:add-specific', {specific: $t('settings/settings:update.update') })"
            :trueFalseDecorateFields="trueFalseDecorateFields"
            icon="edit"
            icon2="delete"
            @clickedButton2="deleteUpdate"
            @updateTableData="updateTable"
            @clickedButton1="editUpdate"
            @clickedAddButton="editUpdate"
            :addBtn="true"
            sortBy="description"
        />

      </v-col>
    </v-row>

    <updateForm
        @updateTable="updateTableAfterManipulation"
        ref="updateForm" />

  </div>
</template>
<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import UpdateForm from "@/modules/settings/views/settings/update/UpdateForm";
import UpdateService from '@/modules/settings/services/update-service';
import Update from '@/modules/settings/data/update';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';


export default {
  name: "UpdateTable",
  components: {
    UpdateForm,
    DataTablePaginated
  },
  computed: {
    headers() {
      return [
        {text: this.$t('settings/settings:update.version'), value: 'version'},
        {text: this.$t('settings/settings:update.channel'), value: 'channel'},
        {text: this.$t('settings/settings:update.os'), value: 'os'},
        {text: this.$t('common:active'), value: 'active'},
        {text: this.$t('common:description'), value: 'description'},
        {text: "", value: "controls", sortable: false}
      ]
    },
    trueFalseDecorateFields() {
      return ['active'];
    }
  },
  methods: {
    updateTable(options, search) {
      if (!search) search = '';

      UpdateService.readAllUpdatesPaginated(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (response) => {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Update);

            this.$refs.table.fillTableData(response.data);
          },
          () => {
            this.$refs.table.loading = false;
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('settings/settings:update.update')}));
          }
      )
    },
    updateTableAfterManipulation() {
      this.$refs.table.callTableUpdate();
    },
    editUpdate(update) {
      this.$refs.updateForm.initialization(update);
    },
    deleteUpdate(update) {
      UpdateService.deleteUpdate(update.id,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('settings/settings:update.update')}));
            this.updateTableAfterManipulation();
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('settings/settings:update.update')}));
          }
      );
    },
  }
}
</script>